import React from 'react';
import {noop} from 'lodash';

import ExpiringWellnessCreditsInfo from '/component/partial/report/ExpiringWellnessCredits';
import {FrontlineClientRole} from '/component/partial/report/FrontlineClientRole';
import {PeopleRole} from '/component/partial/report/PeopleRole';
import PersonFullName from '/component/partial/report/PersonFullName';
import {EXPIRING_WELLNESS_CREDITS} from '/enum/peopleToContact.enum';
import {
  REPORT_CLIENT_TO_CONTACT,
  REPORT_CLIENT_TO_CONTACT_EXPIRING_WELLNESS_CREDITS,
} from '/enum/records.enum';
import {FILTER_TYPES} from '/enum/tealium.enum';

import {generateOnRecordPress} from '../PeopleToContact.util';
import {PeopleToContactDataProvider} from '../PeopleToContactDataProvider';

import {useRecordsSorting} from '/context/RecordsSort/useRecordsSorting';

interface FeatureFlag {
  CC_SR: boolean;
}

interface ExpiringWellnessCreditsProps {
  featureFlag: FeatureFlag;
  onItemPress: (item: any) => void;
  onShowProfile: () => void;
  showFullReport: boolean;
  parentScreenName: string;
  reportParams: any;
}

export const ExpiringWellnessCredits: React.FC<
  ExpiringWellnessCreditsProps
> = ({
  onItemPress = noop,
  onShowProfile = noop,
  parentScreenName = '',
  showFullReport = false,
  reportParams = null,
  featureFlag = {
    CC_SR: false,
  },
}) => {
  const {sortParam} = useRecordsSorting({
    recordsName: REPORT_CLIENT_TO_CONTACT_EXPIRING_WELLNESS_CREDITS,
  });

  const onViewMore = () => {
    onItemPress({
      value: 0,
      recordsName: REPORT_CLIENT_TO_CONTACT,
      filterName: REPORT_CLIENT_TO_CONTACT_EXPIRING_WELLNESS_CREDITS,
    });
  };

  // if the context has not been initialized yet, we take sorting from
  // the parent (default sorting)
  const defaultSorting = sortParam?.params
    ? [{...sortParam?.params}]
    : reportParams;

  return (
    <PeopleToContactDataProvider
      screenParams={{type: EXPIRING_WELLNESS_CREDITS}}
      clientMilestone={FILTER_TYPES.expiringWellnessCredits}
      onViewMore={onViewMore}
      reportParams={defaultSorting}
      reportName={REPORT_CLIENT_TO_CONTACT_EXPIRING_WELLNESS_CREDITS}
      parentScreenName={parentScreenName}
      alternateItemKey="uniqueId"
      dataRendererProps={{
        personNameComponent: PersonFullName,
        personRoleComponent: featureFlag.CC_SR
          ? PeopleRole
          : FrontlineClientRole,
        personInfoComponent: ExpiringWellnessCreditsInfo,
        onRecordPress: generateOnRecordPress({
          onShowProfile,
        }),
        showFullReport,
      }}
    />
  );
};
